module.exports = __webpack_public_path__ + "static/media/chevron-circle-up.8a38757f.svg";